import { PayloadAction, createAction, createSlice } from "@reduxjs/toolkit";

const clearAction = createAction("clear");

export interface JsonEditorState {
  isDarkTheme: boolean;
}

const initialState: JsonEditorState = {
  isDarkTheme: false,
};

const jsonEditorSlice = createSlice({
  name: "jsonEditor",
  initialState,
  reducers: {
    setJsonEditorTheme: (state, action: PayloadAction<boolean>) => {
      state.isDarkTheme = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(clearAction, () => initialState);
  },
});

export const { setJsonEditorTheme } = jsonEditorSlice.actions;
export default jsonEditorSlice.reducer;
